<template>
  <div>
    <b-tabs>
      <b-tab
        title="Normal Zone"
      >
        <zone-form :is-new="true" />

      </b-tab>
      <b-tab title="Closed Zone">
        <closed-zone-form />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import { BTabs, BTab } from 'bootstrap-vue'
import ZoneForm from './components/ZoneForm.vue'
import ClosedZoneForm from './components/closed-zone/ClosedZoneForm.vue'

export default {
  components: {
    ZoneForm,
    BTabs,
    BTab,
    ClosedZoneForm,
  },
}
</script>
